import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaInbox } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaShoppingCart } from "react-icons/fa";
import { FaBookOpen } from "react-icons/fa";
import { FaRegCalendarAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useProfileStore } from "../../store/useUserStore";

const Footer = () => {
    const location = useLocation()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const queryParams = new URLSearchParams(location.search)
    const from = queryParams.get('from')

    const isActive = (path: string) => {
        if (path === "/") {
            // Active for home, course, or item pages — also treat `from=cart` as home
            return (
                location.pathname === "/" ||
                (location.pathname.startsWith("/course/") && !location.pathname.includes("/edit") && from !== "cart") ||
                (location.pathname.startsWith("/item/") && from !== "cart") ||
                from === "cart"
            );
        }

        if (path === "/cart") {
            const isOnCartPage = location.pathname.startsWith("/cart");
            const isOnHistoryPage = location.pathname.startsWith("/payment-history");

            const isCourseEdit = location.pathname.startsWith("/course/") && location.pathname.includes("/edit");

            return (
                isOnCartPage ||
                isOnHistoryPage ||
                isCourseEdit // treat course edit pages as part of cart tab
            ) && !(from === "cart" && !isOnCartPage && !isCourseEdit);
        }

        return location.pathname.startsWith(path);
    }

    const {lastVisitedCourseId, setLastVisitedCourseId} = useProfileStore((state) => state)

    const handleNavigation = (path: string) => {
        if (path === "/") {
            if (lastVisitedCourseId && from !== "cart") {
                return navigate(`/course/${lastVisitedCourseId}`)
            } else if (from === 'cart') {
                setLastVisitedCourseId(null)
            }
        // else {
        //     return navigate(`/`)
        // }
        }
        return navigate(path)
    }

    return (
        <footer className="fixed bottom-0 left-0 right-0 z-[1000] mx-auto max-w-[640px] flex justify-between px-8 md:px-12 py-1 bg-white rounded-[40px] shadow-md">
            <button className={`relative w-[56px] h-[56px] text-center rounded-full ${ isActive("/") ? "bg-theme" : "" }`} onClick={() => handleNavigation("/")} >
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 leading-none">
                <FaBookOpen className={`mx-auto mb-[2px] text-[18px] ${isActive("/") ? "text-white" : "text-gray-400"}`} />
                <span className={`text-[12px] ${isActive("/") ? "text-white" : "text-gray-400"}`}>
                    {t("footer.home")}
                </span>
                </div>
            </button>

            <button className={`relative w-[62px] h-[62px] text-center rounded-full ${ isActive("/cart") ? "bg-theme" : "" }`} onClick={() => navigate("/cart")} >
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 leading-none">
                <FaShoppingCart className={`mx-auto mb-[2px] text-[18px] ${isActive("/cart") ? "text-white" : "text-gray-400"}`} />
                <span className={`text-[12px] ${isActive("/cart") ? "text-white" : "text-gray-400"}`}>
                    {t("footer.cart")}
                </span>
                </div>
            </button>

            <button className={`relative w-[62px] h-[62px] text-center rounded-full ${ isActive("/inbox") ? "bg-theme" : "" }`} onClick={() => navigate("/inbox")} >
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 leading-none">
                <FaInbox className={`mx-auto mb-[2px] text-[18px] ${isActive("/inbox") ? "text-white" : "text-gray-400"}`} />
                <span className={`text-[12px] ${isActive("/inbox") ? "text-white" : "text-gray-400"}`}>
                    {t("footer.inbox")}
                </span>
                </div>
            </button>

            <button className={`relative w-[62px] h-[62px] text-center rounded-full ${ isActive("/schedule") ? "bg-theme" : "" }`} onClick={() => navigate("/schedule")} >
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 leading-none">
                <FaRegCalendarAlt className={`mx-auto mb-[2px] text-[18px] ${isActive("/schedule") ? "text-white" : "text-gray-400"}`} />
                <span className={`text-[12px] ${isActive("/schedule") ? "text-white" : "text-gray-400"}`}>
                    {t("footer.schedule")}
                </span>
                </div>
            </button>

            <button className={`relative w-[62px] h-[62px] text-center rounded-full ${ isActive("/profile") || location.pathname.startsWith("/children/") ? "bg-theme" : "" }`} onClick={() => navigate("/profile")} >
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 leading-none">
                <FaUser className={`mx-auto mb-[2px] text-[18px] ${ isActive("/profile") || location.pathname.startsWith("/children/") ? "text-white" : "text-gray-400" }`} />
                <span className={`text-[12px] ${ isActive("/profile") || location.pathname.startsWith("/children/") ? "text-white" : "text-gray-400" }`}>
                    {t("footer.profile")}
                </span>
                </div>
            </button>
        </footer>
    );
};

export default Footer;
